import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {useStationInfiniteQuery} from "./query";
import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";



const StationsAutocomplete = ({ selectedStations, setSelectedStations, stationFilters={}, fieldProps={}, ...props }) => {
    const {t} = useTranslation(["inputs"]);

    const [hasFocus, setHasFocus] = useState(false);
    const [stationSearch, setStationSearch] = useState("");
    const stationSearchQuery = useStationInfiniteQuery({search: stationSearch, ...stationFilters}, hasFocus);

    const stationOptions = [
        ...selectedStations,
        ...(stationSearchQuery.data?.pages?.flatMap((page) => page.items) ?? []).filter((s) => !selectedStations.find(({id}) => id === s.id)),
    ]

    const handleStationSearch = debounce((value) => {
        setStationSearch(value);
    }, 300);

    return <Autocomplete
        multiple
        id="station-autocomplete"
        options={stationOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(station) => `${station.code} - ${station.name}`}
        value={selectedStations}
        defaultValue={selectedStations}
        filterOptions={(x) => x}
        loading={stationSearch.isFetching}
        onChange={(e, value) => setSelectedStations(value)}
        onClose={() => handleStationSearch("")}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        ListboxProps={{onScroll: getScrollHandler(stationSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleStationSearch(e.target.value)}
                     variant="standard"
                     label={t('stationsAutocomplete.label')}
                     placeholder={t('stationsAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={stationSearchQuery} params={params} /> ),
                     }}
                     {...fieldProps}
            />
        )}
        {...props}
    />
}

export default StationsAutocomplete;